import script from "./ViewPokemonsPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPokemonsPublic.vue?vue&type=script&setup=true&lang=js"

import "./ViewPokemonsPublic.vue?vue&type=style&index=0&id=3d2e703f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2e703f"]])

export default __exports__